define('modules/profiles/subviews/views/profile.salesforce.link.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/salesforce/drawer/views/base.salesforce.link.view',
    "text!modules/profiles/subviews/templates/profile.salesforce.link.template.html"
], function(
    Prospector,
    $, _,Backbone,
    BaseSalesforceLinkSubView,
    Template
){
    var ProfileSalesforceLinkSubView = BaseSalesforceLinkSubView.extend({
        template: _.template(Template),
        onRender:function(){
            $('.pageTitle').html(this.parent.model.get('firstName') + ' ' + this.parent.model.get('lastName'));
        },
        buildLink:function(){
            var mModel = this.parent.model;
            var link = 'profile/' + mModel.get('identityType') + '/' + mModel.get('source').sourceId + '/' + mModel.get('source').refId + '?draw=salesForce';
            return link;
        }
    });
    return ProfileSalesforceLinkSubView;
});
